import { render, staticRenderFns } from "./materials.vue?vue&type=template&id=e806c456&scoped=true&"
import script from "./materials.vue?vue&type=script&lang=js&"
export * from "./materials.vue?vue&type=script&lang=js&"
import style0 from "./materials.vue?vue&type=style&index=0&id=e806c456&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e806c456",
  null
  
)

export default component.exports